import type { CSSProperties } from "react";

export function sonnerStyle(style: CSSProperties | undefined, isMobile: boolean): CSSProperties {
  const mobileStyle = isMobile ? { "--width": "min(22rem, calc(100vw - 1.5rem))" } : undefined;

  return {
    "--normal-bg": "var(--popover)",
    "--normal-text": "var(--popover-foreground)",
    "--normal-border": "var(--border)",
    "--border-radius": "var(--radius)",
    ...style,
    ...mobileStyle,
  } as CSSProperties;
}
